<script lang="ts" setup>
import type { IProps } from './UiList.types'

defineProps<IProps>()
</script>

<template>
  <ul
    :class="[
      'list',
      `list__${list.type}`,
      `list__${list.layout}`
    ]"
  >
    <li
      v-for="(item, index) in list.items"
      :key="index"
      class="list__item"
    >
      <span
        class="list__item_icon"
        :style="{ backgroundImage: `url(${list.icon.url})` }"
      />
      
      <span class="list__item_text">
        {{ item.title }}
      </span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.list {
  $root: &;

  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 2.4rem;

  &__item {
    display: flex;
    align-items: center;
    font-weight: 500;

    &_icon {
      display: inline-block;
      margin-right: 1.6rem;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  &__dot {
    margin-bottom: 4rem;
    #{$root}__item {
      font-size: 2rem;
      line-height: 2.8rem;

      &_icon {
        min-width: 3.2rem;
        width: 3.2rem;
        height: 3.2rem;
      }
    }

    @include atM {
      gap: 1.6rem 4rem;
      margin-top: 4rem;

      &.list__row {
        #{$root}__item {
          width: calc(50% - 2rem);
        }
      }
    }
  }

  &__checkmark,
  &__checkmark-blue {
    margin-bottom: 3.2rem;
    #{$root}__item {
      color: $text-200;
      font-size: 1.6rem;
      line-height: 2.4rem;
      &_icon {
        min-width: 4rem;
        width: 4rem;
        height: 4rem;
      }
    }

    @include atM {
      gap: 2.8rem 4.8rem;
      margin-top: 6.4rem;
      margin-bottom: 5.6rem;

      #{$root}__item {
        width: calc(50% - 2.4rem);
        font-size: 1.8rem;
      }
    }
  }

  &__checkmark-blue {
    #{$root}__item {
      color: $text-400;
      font-size: 1.4rem;
      line-height: 2rem;

      @include atM {
        width: 100%;
        font-size: 2rem;
        line-height: 2.8rem;
      }
    }
  }
  
  &__box {

    @include atXS {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 2rem;
    }

    #{$root}__item {
      justify-content: center;
      padding: 2rem;
      font-size: 2rem;
      line-height: 2.8rem;
      border: 0.1rem solid $gray-300;
      border-radius: 1.6rem;

      @include atXS {
        width: calc(33% - 1.2rem)
      }
    }
  }

  @include atM {
    &__row {
      flex-direction: row;
      flex-wrap: wrap;
    }

    &__checkmark-blue {
      flex-direction: column;
    }
  }
}
</style>
